import React from "react";
import img1 from "./img1.jpeg";
import DarkModeToggler from "../darkModeToggler/DarkModeToggler";
import {
  MdSkipNext,
  MdBookmark,
  MdSkipPrevious,
  MdReplay30,
  MdPause,
  MdForward30,
  MdPlayArrow
} from "react-icons/md";

const MusicPlayer = () => {
  const [isPlaying, setIsPlaying] = React.useState(true);

  return (
    <>
      <h1 className="text-3xl mb-2">Music player</h1>
      <DarkModeToggler />
      <div
        className={`rounded-2xl shadow-2xl border border-black border-opacity-20 bg-gray-50 
          dark:bg-gray-700 dark:text-gray-50 md:w-8/12 lg:w-5/12 overflow-hidden
          transition-all duration-500
        `}
      >
        <div className="p-4">
          <div className="flex flex-col sm:flex-row">
            <div className="flex justify-center sm:justify-start">
              <img
                src={img1}
                className="sm:mr-4 rounded-xl h-20 w-20 overflow-hidden"
              />
            </div>
            <div className="flex-col flex-grow mb-5">
              <div className="text-green-600 font-bold text-center sm:text-left">
                #3
              </div>
              <div className="text-xl font-semibold text-center sm:text-left">
                One Step Closer
              </div>
              <div className="text-base text-center sm:text-left">
                Linkin Park (Hybrid Theory)
              </div>
            </div>
          </div>
          <div className="rounded-full mt-1 h-2 w-full relative border border-black dark:border-gray-500  border-opacity-20">
            <div className="rounded-full absolute left-0 w-2/6 bg-green-600 top-0 h-1.5"></div>
          </div>
          <div className="flex mt-1">
            <div className="w-6/12 text-gray-500 text-lg font-semibold dark:text-gray-300">
              1:26
            </div>
            <div className="w-6/12 text-right text-gray-500 text-lg font-semibold dark:text-gray-300">
              5:32
            </div>
          </div>
        </div>
        <div className="flex justify-center dark:bg-gray-800 transition-all duration-500">
          <div className="p-5 flex justify-between items-center w-full">
            <MdBookmark size={20} className="cursor-pointer" />
            <MdSkipPrevious size={20} className="cursor-pointer" />
            <MdReplay30 size={30} className="cursor-pointer" />
            {isPlaying ? (
              <div
                onClick={() => setIsPlaying(false)}
                className="p-5 border rounded-full shadow-2xl border-black dark:border-white border-opacity-25 cursor-pointer transform transition-transform hover:-translate-y-1 duration-500"
              >
                <MdPause size={30} className="cursor-pointer" />
              </div>
            ) : (
              <div
                onClick={() => setIsPlaying(true)}
                className="p-5 border rounded-full shadow-2xl border-black dark:border-white border-opacity-25 cursor-pointer transform transition-transform hover:-translate-y-1 duration-500"
              >
                <MdPlayArrow size={30} className="cursor-pointer" />
              </div>
            )}
            <MdForward30 size={30} className="cursor-pointer" />
            <MdSkipNext size={20} className="cursor-pointer" />
            <div className="p-2 rounded-xl border cursor-pointer">1.0x</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MusicPlayer;
